import React, { useEffect, useState } from "react";
import CommonTab from "../../../components/TabComponent/CommonTab";
import LevelDetail from "./levelDetail";
import TransferDetail from "./transferDetail";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useTransferMode from "../../../hook/useTransferMode";

const TAB = [
  { label: "Level", value: "level" },
  { label: "My points", value: "myPoints", showWhenTransferMode: true },
];

const VipBar = () => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`vip.${key}`, { ...props });

  const [tab, setTab] = useState(TAB[0].value);

  const isTriggerTransferTab = useSelector(
    (state) => state.isTriggerTransferTab
  );
  const isTransferMode = useTransferMode();

  useEffect(() => {
    setTab(TAB[1].value);

    if (!isTransferMode) {
      setTab(TAB[0].value);
      return;
    }
  }, [isTriggerTransferTab, isTransferMode]);
  return (
    <div className="p-[8px]  md:bg-transparent bg-base-white dark:bg-base-dark">
      <section className="flex items-center mb-[10px]">
        {TAB.filter((item) => {
          if (isTransferMode) {
            return item;
          } else {
            return !item.showWhenTransferMode;
          }
        }).map((item, index) => {
          return (
            <CommonTab
              key={index}
              setTab={setTab}
              tab={tab}
              label={i18n(item.label)}
              value={item.value}
            />
          );
        })}
      </section>
      <section>
        {tab === "level" ? <LevelDetail /> : <TransferDetail />}
      </section>
    </div>
  );
};

export default VipBar;
